module.exports = __webpack_public_path__ + "static/feature-phone-mobile-3-b6848deaede5ad63865f74b47a2bb568.png";